// #region imports

// --- HS Code
import { CommandOfT } from "../shared/command";
import { GroupModel } from "./group-model";
import { Respondent } from "./respondent";
import { RespondentModel } from "./respondent-model";
import { RespondentStatuses } from "./respondent-statuses";

// #endregion

export class DeleteRespondentCommand implements CommandOfT<GroupModel[]> {

  private _isExecuted: boolean;

  private readonly _deletedRespondent: RespondentModel;
  private readonly _groups: GroupModel[];

  get groups(): GroupModel[] {
    if (!this._isExecuted) throw new Error('The command has not yet been executed. No changes have been affected!');
    return this._groups;
  }

  constructor(respondent: RespondentModel, groups: GroupModel[]) {
    this._isExecuted = false;

    this._deletedRespondent = respondent;
    this._groups = groups;
  }

  execute(): GroupModel[] {
    if (this._isExecuted) return this._groups;

    const respondentGroup = this._groups.find(g => g.id.toLowerCase() === this._deletedRespondent.groupId.toLowerCase());
    if (respondentGroup) {
      const respondentIndex = respondentGroup.respondents.findIndex(r => r.emailAddress.toLowerCase() === this._deletedRespondent.emailAddress.toLowerCase());
      if (respondentIndex >= 0) {
        respondentGroup.respondents.splice(respondentIndex, 1);
        respondentGroup.respondents.forEach(r => {
          if (r.groupIndex > this._deletedRespondent.groupIndex) r.groupIndex--;
        });
        const newGroupIndex = (Math.max(...respondentGroup.respondents.map(r => r.groupIndex)) ?? 0) + 1;
        respondentGroup.respondents.push(Respondent.CreateEmpty(respondentGroup.id, newGroupIndex, respondentGroup.participantId));
      }
      respondentGroup.isDirty = true;
    }

    this._isExecuted = true;
    return this._groups;
  }

  undo(): GroupModel[] {
    if (!this._isExecuted) return this._groups;

    const respondentGroup = this._groups.find(g => g.id.toLowerCase() === this._deletedRespondent.groupId.toLowerCase());
    if (respondentGroup) {
      const respondentIndex = respondentGroup.respondents.findIndex(r => r.groupIndex === this._deletedRespondent.groupIndex);
      if (respondentIndex >= 0) {
        respondentGroup.respondents.pop();
        respondentGroup.respondents.forEach(r => {
          if (r.groupIndex >= this._deletedRespondent.groupIndex) r.groupIndex++;
        });
        respondentGroup.respondents.splice(respondentIndex, 0, this._deletedRespondent);
      }
    }

    return this._groups;
  }
}
